var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCruiseControl32 = function SvgCruiseControl32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.95 25.765-1.934 2.23C9.099 25.923 7.992 22.945 8 20.107a11.207 11.207 0 0 1 3.016-7.625 10.964 10.964 0 0 1 7.363-3.463 10.942 10.942 0 0 1 7.71 2.58 11.092 11.092 0 0 1 2.919 3.886 11.211 11.211 0 0 1 .99 4.775 10.948 10.948 0 0 1-2.15 6.49c-.09.114-1.173 1.336-1.26 1.245l-2.088-2.23M14 14l5 6M2 3l6 6m11 0v3m7.121 1L24 15.121M29.25 20h-3M11 20H8",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.118 8.661 4.546-4.546a.394.394 0 0 1 .659.177l1.664 6.213a.395.395 0 0 1-.485.481L3.295 9.324a.394.394 0 0 1-.177-.663Z",
    fill: "currentColor"
  })));
};
export default SvgCruiseControl32;